<template>
    <div ref="targetContainer">
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <chat-items-component v-if="!isLoading"
            :title="'疼痛舒緩Ｑ＆Ａ'"
            :titleh1="'疼痛舒緩Ｑ＆Ａ'"
            :column-row="true"
            :show-more="'show'"
            :chat-items="items"
            :post-max-size="postMaxSize"
            :upload-max-size="uploadMaxSize"
            :max-file-uploads="maxFileUploads"
            :last-page="lastPage"
            :total-count="total"
            :each-page-item-count="perPage"
            :fetch-url="'/onlineMedicalConsultation/getChatItems'"
            :auth-check="authCheck"
            :auth-user-id="authUserId"
            :statement="statement"
            :position="'block'"
            :page-path="pagePath"
        ></chat-items-component>
    </div>
</template>

<script>

import ChatItemsComponent from 'Vue/Web/Common/OnlineMedical/ChatItemsComponent.vue';

export default {
    name: 'ClinicOnlineMedical',
    components: {
        ChatItemsComponent,
    },
    props: {
        id: {
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 0,
        },
        postMaxSize: {
            type: Number,
            default: 0,
        },
        uploadMaxSize: {
            type: Number,
            default: 0,
        },
        maxFileUploads: {
            type: Number,
            default: 0,
        },
        authCheck: {
            type: Boolean,
            default: false,
        },
        authUserId: {
            type: Number,
            default: 0,
        },
        statement: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        pagePath: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 'clinic',
        }
    },
    data() {
        return {
            isLoading: true,
            items: [],
            total: 0,
            lastPage: 0,
            perPage: 4,
            url: '/api/getClinicOnlineMedical',
            doctorNum: 0,
        };
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    beforeDestroy() {
    },
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 20% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.getResult();
                        observer.unobserve(this.$refs.targetContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.targetContainer) {
                observer.observe(this.$refs.targetContainer);
            }
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.id}`);
                this.items = response.data.data;
                this.total = response.data.total;
                this.lastPage = response.data.last_page;
                this.perPage = response.data.per_page;
                this.isLoading = false;
                this.$nextTick(() => {
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
    computed: {},
};
</script>

<style scoped lang="scss">
.spinner-border{
    margin: 50px 50%;
}
</style>
